// extracted by mini-css-extract-plugin
export default {"popoverWrapper":"Popover_popoverWrapper__X-d1u","popoverOpen":"Popover_popoverOpen__NmQ8A","fadeIn":"Popover_fadeIn__TU6lG","fadeOut":"Popover_fadeOut__VFhHa"};